import { create } from 'zustand';

import type { OrganizationUiSettings } from '../types';

interface OrgUiSettingsState {
  /** Effective experience & module settings of the active org, or null until loaded. */
  settings: OrganizationUiSettings | null;
  /**
   * True once the first load attempt settled (settings, no org, or a failed
   * fetch). Route guards wait for it: deciding on the defaults would treat the
   * org's modules as off and bounce a reloaded page to the landing page.
   */
  loaded: boolean;
  setSettings: (settings: OrganizationUiSettings | null) => void;
}

/** Not persisted — reloaded from the API on each app start (see useOrgModules). */
export const useOrgUiSettingsStore = create<OrgUiSettingsState>((set) => ({
  settings: null,
  loaded: false,
  setSettings: (settings) => set({ settings, loaded: true }),
}));
